module.exports = __webpack_public_path__ + "img/icon-location-blue.c0de0cd1.svg";